import type { AiChapterId, SceneDefinition, SceneId, StoredProgress } from "../types";
import { SHARED_SCENE_GUIDE_CATALOG } from "../../shared/sceneGuideCatalog";

/** 旅程的唯一场景顺序、证据边界和正式计分规则映射。 */
export const sceneDefinitions: readonly SceneDefinition[] = SHARED_SCENE_GUIDE_CATALOG.map((entry) => ({
  id: entry.sceneId,
  chapterId: entry.chapterId,
  title: entry.objectiveLabel,
  step: entry.sceneStep,
  order: entry.order,
  evidenceIds: [...entry.evidenceIds],
  ruleIds: [...entry.ruleIds]
}));

const SCENE_BY_ID = new Map(sceneDefinitions.map((scene) => [scene.id, scene]));

export function getSceneDefinition(sceneId: SceneId): SceneDefinition {
  const scene = SCENE_BY_ID.get(sceneId);
  if (!scene) throw new Error(`未知场景：${sceneId}`);
  return scene;
}

export function getScenesForChapter(chapterId: AiChapterId): readonly SceneDefinition[] {
  return sceneDefinitions.filter((scene) => scene.chapterId === chapterId);
}

/** 场景开始后，只有全部本地规则已掌握时才能进入“已掌握”状态。 */
export function canCompleteScene(progress: StoredProgress, sceneId: SceneId): boolean {
  const sceneProgress = progress.scenes[sceneId];
  if (!sceneProgress || sceneProgress.status === "not-started") return false;
  const mastered = new Set(sceneProgress.masteredRuleIds);
  return getSceneDefinition(sceneId).ruleIds.every((ruleId) => mastered.has(ruleId));
}
